import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var f = filter.toLowerCase()
  var c = column.value.toLowerCase()

  if(_.includes(c,f)){
    return true
  } else {
    return false
  }

}

export function getFormField(o,p,field){

  var value = {
    b: null,
    c: null,
    s: null,
  }

  if(field.value){
    value.b = field.value.split('_')[0].replace('b','')
    value.c = field.value.split('_')[1].replace('c','')
    value.s = field.value.split('_')[2].replace('s','')
  }

  var parse = function(value){
    if(value.b || value.c || value.s){
      return 'b' + (value.b || 0) + '_c' + (value.c || 1) + '_s' + (value.s || 1)
    } else {
      return null
    }
  }

  var validate = function(){
    value = {
      b: inputBrightnessDiv.val(),
      c: inputContrastDiv.val(),
      s: inputSaturationDiv.val(),
    }
    if(
      (!value.b || (value.b * 1 == value.b && value.b >= -1 && value.b <= +1)) &&
      (!value.c || (value.c * 1 == value.c && value.c >= -2 && value.c <= +2)) &&
      (!value.s || (value.s * 1 == value.s && value.s >= 0 && value.s <= +3))
    ){
      var valueParsed = parse(value)
      o.player.setFilter(valueParsed)
      p.change(field,valueParsed,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      o.player.setFilter()
      p.change(field,null,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var labelDiv =
    button(field.id + ' (b/c/s)',null,true)
    .css({
      display: 'block',
    })

  var previewDiv =
    button(null,'fi-magnifying-glass',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(validate)

  var clearDiv =
    button(null,'fi-x',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: '34px',
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(function(){
      inputBrightnessDiv.val('')
      inputContrastDiv.val('')
      inputSaturationDiv.val('')
      validate()
    })

  var disabled = field.edit ? false : true

  var brightnessIcon =
    button(null,'custom-brightness',true,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })

  var decBrightnessButton =
    button(null,'fi-minus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.b === ''){
        value.b = 0
      }
      if(value.b * 1 - 0.1 >= -1){
        value.b = _.round(value.b  * 1 - 0.1, 1)
        inputBrightnessDiv.val(value.b)
        validate()
      }
    })

  var incBrightnessButton =
    button(null,'fi-plus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.b === ''){
        value.b = 0
      }
      if(value.b * 1 + 0.1 <= 1){
        value.b = _.round(value.b  * 1 + 0.1, 1)
        inputBrightnessDiv.val(value.b)
        validate()
      }
    })

  var inputBrightnessDiv =
    input(disabled)
    .css({
      display: 'inline-block',
      width: '61px',
    })
    .attr({
      title: 'brightness: -1 to +1, def 0',
    })
    .val(
      value.b
    )
    .on('keyup',function(){
      if(inputBrightnessDiv.val()){
        value.b = inputBrightnessDiv.val()
      } else {
        value.b = null
      }
      validate()
    })

  var contrastIcon =
    button(null,'custom-contrast',true,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })

  var decContrastButton =
    button(null,'fi-minus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.c === ''){
        value.c = 1
      }
      if(value.c * 1 - 0.1 >= -2){
        value.c = _.round(value.c  * 1 - 0.1, 1)
        inputContrastDiv.val(value.c)
        validate()
      }
    })

  var incContrastButton =
    button(null,'fi-plus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.c === ''){
        value.c = 1
      }
      if(value.c * 1 + 0.1 <= 2){
        value.c = _.round(value.c  * 1 + 0.1, 1)
        inputContrastDiv.val(value.c)
        validate()
      }
    })

  var inputContrastDiv =
    input(disabled)
    .css({
      display: 'inline-block',
      width: '61px',
    })
    .attr({
      title: 'contrast: -2 to +2, def 1',
    })
    .val(
      value.c
    )
    .on('keyup',function(){
      if(inputContrastDiv.val()){
        value.c = inputContrastDiv.val()
      } else {
        value.c = null
      }
      validate()
    })

  var saturationIcon =
    button(null,'custom-saturation',true,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })

  var decSaturationButton =
    button(null,'fi-minus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.s === ''){
        value.s = 1
      }
      if(value.s * 1 - 0.1 >= 0){
        value.s = _.round(value.s  * 1 - 0.1, 1)
        inputSaturationDiv.val(value.s)
        validate()
      }
    })

  var incSaturationButton =
    button(null,'fi-plus',false,colors.white)
    .css({
      display: 'inline-block',
      borderRight: `1px solid ${colors.black}`,
      width: '24px',
      paddingLeft: '4px',
    })
    .click(function(){
      if(value.s === ''){
        value.s = 1
      }
      if(value.s * 1 + 0.1 <= 3){
        value.s = _.round(value.s  * 1 + 0.1, 1)
        inputSaturationDiv.val(value.s)
        validate()
      }
    })

  var inputSaturationDiv =
    input(disabled)
    .css({
      display: 'inline-block',
      width: '61px',
    })
    .attr({
      title: 'saturation: 0 to +3, def 1',
    })
    .val(
      value.s
    )
    .on('keyup',function(){
      if(inputSaturationDiv.val()){
        value.s = inputSaturationDiv.val()
      } else {
        value.s = null
      }
      validate()
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      previewDiv,
      clearDiv,
      brightnessIcon,
      decBrightnessButton,
      incBrightnessButton,
      inputBrightnessDiv,
      contrastIcon,
      decContrastButton,
      incContrastButton,
      inputContrastDiv,
      saturationIcon,
      decSaturationButton,
      incSaturationButton,
      inputSaturationDiv,
    )

  requestAnimationFrame(function(){
    validate()
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/filter/filter.js